/** Get all data in a certain page. */
export const getPageData = <T>(data: T[], page: number, itemsPerPage: number): T[] => {
  const pageStart = itemsPerPage * (page - 1);
  const pageEnd = pageStart + itemsPerPage;

  return data.slice(pageStart, pageEnd);
};
